import ApiService from '../service/ApiService';

let 
moduleApi = {};
let moduleName = "diem_den_an_toan";

moduleApi.create = (dataForm) => {
    let api = {
        module: moduleName,
        type: "create",
        value: dataForm
    };
    return ApiService(api);
};

moduleApi.update = (dataForm) => {
    let api = {
        module: moduleName,
        type: "partialUpdate",
        value: dataForm
    };
    return ApiService(api);
};

moduleApi.updateDuyet = (dataForm) => {
    let api = {
        module: moduleName,
        type: "partialUpdate",
        value: dataForm,
        message: {
            success: "Duyệt thành công", //string | null | comment
            error: "", //string | null | comment
        },
    };
    return ApiService(api);
};

moduleApi.updateHuyDuyet = (dataForm) => {
    let api = {
        module: moduleName,
        type: "partialUpdate",
        value: dataForm,
        message: {
            success: "Bỏ duyệt thành công", //string | null | comment
            error: "", //string | null | comment
        },
    };
    return ApiService(api);
};

moduleApi.list = (dataFilter) => {
    let api = {
        module: moduleName,
        type: "list",
        value: dataFilter
    };
    return ApiService(api);
};

moduleApi.delete = (id) => {
    let api = {
        module: moduleName,
        type: "delete",
        value: { id: id }
    };
    return ApiService(api);
};

moduleApi.findById = (id, fields) => {
    let api = {
        module: moduleName,
        type: "findById",
        value: { id: id, fields: fields },
    };
    return ApiService(api);
};


moduleApi.importDDAT = (ddatInfos) => {
    let api = {
      module: moduleName,
      type: "import_ddat_excel",
      value: {
        ddats: ddatInfos
      },
      params: {
        
      },
      message: {
        success: null, //string | null | comment
        error: null,  //string | null | comment
      }
  
    };
    return ApiService(api);
  };

moduleApi.clearCache = () => {
    ApiService.clearCache(new RegExp("/" + moduleName + "s([/?#].*)?$"));
};

moduleApi.declaredCalendar = (data) => {
    let api = {
        module: moduleName,
        type: "views",
        viewAction: "declared_calendar",
        value: data
    }
    return ApiService(api);
}

moduleApi.declaredStatusCalendar = (data) => {
    let api = {
        module: moduleName,
        type: "views",
        viewAction: "declared_status_calendar",
        value: data
    }
    return ApiService(api);
}

export default moduleApi;